module.exports = __webpack_public_path__ + "img/md_gm.e70ca09d.png";